import React from "react";
import {
  Container,
  Typography,
  Box,
  List,
  ListItem,
  Link,
} from "@mui/material";

const ShippingPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Shipping & Delivery Policy
      </Typography>

      <Typography variant="subtitle2" align="center" gutterBottom>
        Last Updated: May 20, 2022
      </Typography>

      <Typography paragraph align="center">
        Please review the following policy carefully. It applies to all purchases made through our platform.
      </Typography>

      <Box my={3}>
        <Typography variant="h6">Shipping & Delivery Options</Typography>

        <Typography variant="subtitle1" sx={{ mt: 2 }}>
          In-Store Pickup
        </Typography>
        <List>
          <ListItem>Available for all purchases.</ListItem>
          <ListItem>Pickup hours: Monday to Friday, 9:00 AM to 6:00 PM.</ListItem>
        </List>

        <Typography variant="subtitle1" sx={{ mt: 2 }}>
          Shipping Methods
        </Typography>
        <List>
          <ListItem>We offer various shipping options.</ListItem>
          <ListItem>
            In some cases, a third-party supplier may manage inventory and handle shipping.
          </ListItem>
        </List>
      </Box>

      <Box my={3}>
        <Typography variant="h6">Free Shipping</Typography>
        <Typography paragraph>
          We offer free standard shipping on orders ₹750 and above.
        </Typography>
      </Box>

      <Box my={3}>
        <Typography variant="h6">Expedited Shipping</Typography>
        <List>
          <ListItem>Standard Delivery Time: 3–21 business days</ListItem>
          <ListItem>Shipping Rate (up to 1 KG): ₹1.05</ListItem>
          <ListItem>
            If expedited shipping is selected, we will follow up post-order with further shipping information.
          </ListItem>
        </List>
        <Typography paragraph>
          <strong>Note:</strong> All delivery timelines are estimates and provided in good faith.
        </Typography>
      </Box>

      <Box my={3}>
        <Typography variant="h6">International Shipping</Typography>
        <Typography paragraph>
          We do not currently offer international shipping.
        </Typography>
      </Box>

      <Box my={3}>
        <Typography variant="h6">Contact Information</Typography>
        <Typography paragraph>
          For any questions regarding this policy, you can contact us at:
        </Typography>
        <Typography paragraph>
          <strong>Phone:</strong> <Link href="tel:+918827373432">+91-8827373432</Link>
        </Typography>
      </Box>
    </Container>
  );
};

export default ShippingPolicy;
